import "./index.less"
import { getMembershipBenefits, getLoginMembershipBenefits, } from '@utils/fetch'
import { cookie, DragToMove, } from '@utils/index'

class RedPacket {
    constructor({ initShow = false, }) {
        // 初始时是否显示，兼容处理
        this.initShow = initShow

        this.el = '#red-packet .packet'

        this.DOM = document.querySelector(this.el)

        this.METHOD = pageInfo.customerInfo.id ? getLoginMembershipBenefits : getMembershipBenefits

        this.linkUrl = `${window.pageInfo.membership_url}/index?cr=${window.pageInfo.cr}`

        this.pointsDOM = this.DOM.querySelector('[data-points]')
        this.pointValueDOM = this.DOM.querySelector('[data-point-value]')
        this.percenterDOM = this.DOM.querySelector('[data-percenter]')

        this.giftcardDOM = this.DOM.querySelector('[data-giftcard]')
        this.giftcardValueDOM = this.DOM.querySelector('[data-giftcard-value]')

        if (this.initShow) {
            this.init()
        }
    }
    async init() {
        const { data: { rightValue, rightValueType, exchangeRightType, currencyTypePrefix, }, } = await this.METHOD()

        // 1 - 优惠券, 2 - 礼品卡, 3 - 其他
        if (exchangeRightType === 1) {
            this.pointsDOM.classList.add('hidden')
            this.giftcardDOM.classList.remove('hidden')

            // 0 - 固定值
            if (rightValueType === 0) {
                this.giftcardValueDOM.innerHTML =
                    currencyTypePrefix === '€'
                        ? `${rightValue}${currencyTypePrefix}`
                        : `${currencyTypePrefix}${rightValue}`
            }
            // 1 - 百分比
            if (rightValueType === 1) {
                this.giftcardValueDOM.innerHTML = `${rightValue}%`
            }
        } else {
            this.pointsDOM.classList.remove('hidden')
            this.giftcardDOM.classList.add('hidden')

            // 0 - 固定值
            if (rightValueType === 0) {
                this.pointValueDOM.classList.remove('hidden')
                this.percenterDOM.classList.add('hidden')

                this.pointValueDOM.innerHTML =
                    currencyTypePrefix === '€'
                        ? `${rightValue}${currencyTypePrefix}`
                        : `${currencyTypePrefix}${rightValue}`
            }
            // 1 - 百分比
            if (rightValueType === 1) {
                this.pointValueDOM.classList.add('hidden')
                this.percenterDOM.classList.remove('hidden')

                this.pointValueDOM.innerHTML = `${rightValue}%`
            }
        }
        

        // 判断是否显示红包
        let redPacketClosed = cookie.get('redPacketClosed')

        if (
            (rightValue && !redPacketClosed) ||
            (rightValue && redPacketClosed && redPacketClosed !== 'hide')
        ) {
            this.DOM.classList.remove('hidden')
            this.DOM.style.display = 'block'
            this.initDrag()
        } else {
            this.DOM.classList.add('hidden')
        }
    }
    initDrag() {
        new DragToMove({
            el: this.el,
            placement: 'right', // 目标位置，'left' - 靠左，'right' - 靠右
            offset: { // 偏移量
                x: 10,
                y: '40%',
            },
            onClick: () => window.open(this.linkUrl),
            closable: true,
            closableEl: '#red-packet-close',
            closedCallback: () => this.closeRedPacket(),
        })
    }
    closeRedPacket() {
        let date = new Date()
        date.setTime(date.getTime() + (24 * 60 * 60 * 1000))
        document.cookie = `redPacketClosed=hide; expires=${date.toGMTString()}; path=/;`
    }
}

// 会员红包
export default RedPacket
